import React from 'react';
import './App.scss';
import Intro from './views/intro';
import Test from './views';

class ACT extends React.Component {
    constructor(props) {
        super(props);
        this.state = { who: undefined, disabled: false, scoreEntries: [0, 0], score: 0, finalScore: 0, step: 0, tempScore: 0 };
        this.formHandler = this.formHandler.bind(this);
        this.answerHandler = this.answerHandler.bind(this);
        this.prevHandler = this.prevHandler.bind(this);
        this.restartHandler = this.restartHandler.bind(this);
        this.printHandler = this.printHandler.bind(this);
        this.getState = this.getState.bind(this);
        this.applySavedInfo = this.applySavedInfo.bind(this);

        this.AppState = {};
    }
    answerHandler(evt) {
        const answer = evt.currentTarget;
        const button = document.querySelector("#act button[disabled]");
        const value = answer.value;
        const id = answer.getAttribute("id");
        const name = answer.getAttribute("name");

        this.AppState[name] = id;
        if (button) {
            console.log(button);
            button.removeAttribute("disabled");
        }
        let arr = this.state.scoreEntries;
        if (this.state.step - 1 > -1) {
            arr[this.state.step - 1] = Number(value);
            this.setState({ scoreEntries: arr });
            const sum = this.state.scoreEntries.reduce(function (a, b) {
                return a + b;
            }, 0);
            this.setState({ finalScore: sum, tempScore: Number(value) });
        }
    }
    restartHandler(evt) {
        this.animateState({ who: undefined, step: 0 });
    }
    printHandler(evt) {
        window.print();
    }
    prevHandler(evt) {
        const step = Number(this.state.step) - 1;
        this.animateState({ step: step });
    }
    formHandler(evt) {
        evt.preventDefault();
        const form = evt.currentTarget;
        let step = Number(this.state.step) + 1;
        const obj = {};
        const selected = form.querySelector("input:checked");
        if (selected) {
            obj[selected.getAttribute("name")] = selected.value;
            this.setState(obj);
        }
        this.animateState({ step: step, tempScore: 0 });
    }
    getState(obj) {
        return this.AppState[obj];
    }
    applySavedInfo() {
        const answer = document.querySelectorAll(".answer");
        if (answer.length !== 0) {
            for (let i = 0; i < answer.length; i++) {
                const input = answer[i].querySelector("input");
                if (input) {
                    const value = this.getState(input.getAttribute("name"));
                    if (value === input.getAttribute("id")) {
                        input.setAttribute("checked", "checked");
                        const button = document.querySelector("button[disabled]");

                        this.setState({ tempScore: input.value });


                        if (button) {
                            button.removeAttribute("disabled");
                        }
                    }
                }
            }
        }
    }
    animateState(obj) {
        const view = document.querySelector(".actView");
        view.classList.remove("fadeIn");
        view.addEventListener('animationend', (evt) => {
            this.setState(obj);
            this.applySavedInfo();
        });
        view.classList.add("fadeOut");
    }
    render() {
        if (this.state.who === undefined) {
            return <Intro formHandler={this.formHandler} answerHandler={this.answerHandler} getState={this.getState} applySavedInfo={this.applySavedInfo} />
        } else {
            return <Test answerHandler={this.answerHandler} restartHandler={this.restartHandler} prevHandler={this.prevHandler} getState={this.getState} Score={this.state.finalScore} TempScore={this.state.tempScore} step={this.state.step} applySavedInfo={this.applySavedInfo} formHandler={this.formHandler} printHandler={this.printHandler} role={this.state.who} />
        }
    }
}


export default ACT;
